document.addEventListener('DOMContentLoaded', function () { 
  /** splide slider */
  var splideElms = document.querySelectorAll( '.splide' );

  splideElms.forEach(e => {

    let enableScrollExt;
    if(e.classList.contains('auto-scroll')) {  
      enableScrollExt = window.splide.Extensions;
    }
    let splideSettings = e.dataset.splide; 
    new Splide( e , splideSettings ).mount( enableScrollExt );
  });
});